import React from "react";
import ReactDOM from "react-dom/client";
import { useState } from "react";
import "./orep.css";
import Multiselect from "multiselect-react-dropdown";
import axios from "axios";
import { countriesTime } from "./countryTimeZones";

const Emailr = () => {
    const [IdCountry, setIdCountry] = useState([0]);
    const [diff, setDiff] = useState([]);
    const [Iddiff, setIddiff] = useState([]);
    const handleCountrySelection = (e) => {
        const value = e.target.value;
        setIdCountry(e.target.value);
        axios
            .get("http://tagard.in:8001/timezones?id=" + value)
            .then((response) => {
                setDiff(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const [devices, setDevices] = useState(["all"]);
    const [devices2, setDevices2] = useState(["all"]);

    const fetchDevices = async (id) => {
        const responseDevice = await axios.get(
            "http://tagard.in:8001/getDevices",
            {
                params: {
                    id: id,
                },
                headers: {
                    accept: "application/json",
                },
            }
        );
        return responseDevice.data;
    };

    const buttonDevices = () => {
        const id = document.getElementById("ide").value;
        setDevices(["all"]);
        fetchDevices(id)
            .then((response) => {
                setDevices([...devices, ...response]);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const fetche = async (id_, dev_, start_, interval_, agg_, Iddiff) => {
        const responseemail = await axios.get(
            "http://tagard.in:8001/sendEmail",
            {
                params: {
                    ID: id_,
                    devices: dev_,
                    Period: start_,
                    Interval: interval_,
                    aggregation: agg_,
                    tz: Iddiff,
                },
                headers: {
                    accept: "application/json",
                },
            }
        );
        return responseemail.data;
    };

    const getEmailResponse = () => {
        const id_ = document.getElementById("ide").value;
        const start_ = document.getElementById("period").value;
        const interval_ = document.getElementById("intervale").value;
        const agg_ = document.getElementById("agge").value;
        fetche(id_, devices2.join(","), start_, interval_, agg_, Iddiff)
            .then((response) => {
                console.log(response);
                console.log("done");
                return response;
            })
            .catch((error) => {
                console.error("Error:", error);
            });
        // console.log(id_, devices2.join(","), start_, interval_, agg_, Iddiff);
    };

    const fetche2 = async (
        id_,
        dev_,
        start_,
        interval_,
        agg_,
        Iddiff,
        temp_,
        Fromhr,
        Tohr
    ) => {
        const responseemail = await axios.get(
            "http://tagard.in:8001/sendEmailpdf",
            {
                params: {
                    ID: id_,
                    devices: dev_,
                    Period: start_,
                    Interval: interval_,
                    aggregation: agg_,
                    tz: Iddiff,
                    fileType: temp_,
                    Fromhr: Fromhr,
                    Tohr: Tohr,
                },
                headers: {
                    accept: "application/json",
                },
            }
        );
        return responseemail.data;
    };

    const getEmailResponse2 = () => {
        const id_ = document.getElementById("ide").value;
        const start_ = document.getElementById("period").value;
        const interval_ = document.getElementById("intervale").value;
        const agg_ = document.getElementById("agge").value;
        const temp = document.getElementById("Temp").value;
        const Fromhr = document.getElementById("Fromhr").value;
        const Tohr = document.getElementById("Tohr").value;

        fetche2(
            id_,
            devices2.join(","),
            start_,
            interval_,
            agg_,
            Iddiff,
            temp,
            Fromhr,
            Tohr,
        )
            .then((response) => {
                console.log(response);
                console.log("done");
                return response;
            })
            .catch((error) => {
                console.error("Error:", error);
            });
        // console.log(id_, devices2.join(","), start_, interval_, agg_, Iddiff);
    };

    return (
        <>
            <h1>Data Explorer through Email</h1>
            <form>
                <input type="number" min="1" placeholder="ID" id="ide"></input>
                <br></br>
                <br></br>
                <div id="horizontal_div">
                    <Multiselect
                        isObject={false}
                        onRemove={(e) => setDevices2(e)}
                        onSelect={(e) => setDevices2(e)}
                        options={devices}
                        id="multi_1"
                        placeholder="Devices"
                    ></Multiselect>
                    <button type="button" id="submit" onClick={buttonDevices}>
                        Refresh
                    </button>
                    <button
                        type="button"
                        id="submit"
                        onClick={() => console.log(devices2)}
                    >
                        see
                    </button>
                </div>
                <br></br>
                <label>
                    The desired duration
                    <select id="period">
                        <option value="1">previous day</option>
                        <option value="7">previous week</option>
                        <option value="30">previous month</option>
                    </select>
                </label>
                <input
                    id="Fromhr"
                    placeholder="From"
                    type="number"
                    max="23"
                    min="0"
                ></input>
                <input
                    id="Tohr"
                    placeholder="To"
                    type="number"
                    max="24"
                    min="0"
                ></input>
                <br></br>
                <input
                    type="number"
                    min="1"
                    placeholder="Interval in min"
                    id="intervale"
                ></input>
                <br></br>
                <label>
                    Aggregation
                    <select id="agge">
                        <option value="mean">Mean</option>
                        <option value="max">Max</option>
                        <option value="min">Min</option>
                        <option value="mode">Mode</option>
                        <option value="median">Median</option>
                    </select>
                </label>
                <div>
                    <select
                        className="mb-3"
                        onChange={(e) => handleCountrySelection(e)}
                        id="CountryId"
                    >
                        <option>Select Country</option>
                        {countriesTime.map((country) => {
                            return (
                                <CountryOptions {...country} key={country.id} />
                            );
                        })}
                    </select>
                </div>
                <div>
                    <select
                        id="diffId"
                        onChange={(e) => {
                            setIddiff(e.target.value);
                        }}
                    >
                        <option>Select Time Zone</option>
                        {diff.map((city) => {
                            return <DiffOptions {...city} key={city.id} />;
                        })}
                    </select>
                </div>
                <br></br>
                <label>
                    Temp or Humidity
                    <select id="Temp">
                        <option value="pdfTempHumidity">
                            pdf Temp & Humidity
                        </option>
                        <option value="pdfTempHumidityNoSummary">
                            pdf Temp & Humidity without summary
                        </option>
                        <option value="pdfTempHumidityNoGraph">
                            pdf Temp & Humidity no graph
                        </option>
                        <option value="pdfTempHumidityOnlyTables">
                            pdf Temp & Humidity tables only
                        </option>

                        <option value="pdfTemp">pdf Temp</option>
                        <option value="pdfTempNoSummary">
                            pdf Temp without summary
                        </option>
                        <option value="pdfTempNoGraph">
                            pdf Temp no graph
                        </option>
                        <option value="pdfTempOnlyTables">
                            pdf Temp tables only
                        </option>

                        <option value="pdfHumidity">pdf Humidity</option>
                        <option value="pdfHumidityNoSummary">
                            pdf Humidity without summary
                        </option>
                        <option value="pdfHumidityNoGraph">
                            pdf Humidity no graph
                        </option>
                        <option value="pdfHumidityOnlyTables">
                            pdf Humidity tables only
                        </option>
                    </select>
                </label>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <button type="button" id="submit" onClick={getEmailResponse}>
                    Submit
                </button>
                <button type="button" id="submit" onClick={getEmailResponse2}>
                    PDF
                </button>
            </form>
            <footer>
                <div>
                    For More information please contact us on
                    reportmaster@tag4track.com
                </div>
            </footer>
        </>
    );
};

const CountryOptions = ({ id, country }) => {
    return (
        <option value={id} id="countryID2">
            {country}
        </option>
    );
};

const DiffOptions = ({ id, UTC }) => {
    return (
        <option value={UTC} id="stateID2">
            {UTC}
        </option>
    );
};
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<Emailr />);
export default Emailr;
